import Cookies from 'js-cookie'
import { baseApi } from '../baseApi'
import { resetAuth, setAuthUser } from '@/redux/auth/authSlice'

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (user) => ({
        url: `/auth/login`,
        method: 'POST',
        body: user,
        // credentials: "include" as const
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          const {
            data: { data },
          } = result
          if (data?.temp_token) {
            Cookies.set('token', data.temp_token)
            return
          }
          Cookies.set('token', data.token)
          dispatch(setAuthUser(data))
        } catch (error: any) {
          // console.log(error)
        }
      },
    }),
    forgotPassword: builder.mutation({
      query: (payload) => ({
        url: `/auth/forgot-password`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    verifyMFAOTP: builder.mutation({
      query: (payload) => ({
        url: `/auth/verify-mfa`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          const {
            data: { data },
          } = result
          Cookies.set('token', data.token)
          dispatch(setAuthUser(data))
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    verifyLoginOTP: builder.mutation({
      query: (payload) => ({
        url: `/auth/verify-otp`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          const {
            data: { data },
          } = result
          Cookies.set('token', data.token)
          dispatch(setAuthUser(data))
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    verifyPasswordResetOTP: builder.mutation({
      query: (payload) => ({
        url: `/auth/verify-password-reset-otp`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          const {
            data: { data },
          } = result
          Cookies.set('token', data.token)
          dispatch(setAuthUser(data))
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    resendOTP: builder.mutation({
      query: (payload) => ({
        url: `/auth/resend-password-reset-otp`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: `/auth/reset-password`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          // console.log('Error:', error)
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: `/auth/logout`,
        method: 'POST',
        // credentials: "include" as const
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          Cookies.remove('token')
          window.location.href = '/'
          dispatch(resetAuth())
        } catch (error: any) {
          console.log('Error:', error)
        }
      },
    }),
    getAuthUserDetails: builder.query({
      query: () => ({
        url: `/user`,
        method: 'GET',
        // credentials: "include" as const
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
          const {
            data: { data },
          } = result
          const key = {
            user: data,
          }

          dispatch(setAuthUser(key))
        } catch (error: any) {
          // console.log(error)
        }
      },
      providesTags: ['Profile'],
    }),
    editProfileDetails: builder.mutation({
      query: (payload) => ({
        url: `/profile`,
        method: 'POST',
        body: payload,
        formData: true,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          console.log('Error:', error)
        }
      },
      invalidatesTags: ['Profile'],
    }),
    changePassword: builder.mutation({
      query: (payload) => ({
        url: `/profile/change/password`,
        method: 'PUT',
        body: payload,
        formData: false,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          console.log('Error:', error)
        }
      },
    }),
    verifyPasswordChange: builder.mutation({
      query: (payload) => ({
        url: `/profile/verify-password-change-otp`,
        method: 'POST',
        body: payload,
        formData: false,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          console.log('Error:', error)
        }
      },
    }),
    updatePassword: builder.mutation({
      query: (payload) => ({
        url: `/profile/initiate-password-change`,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled
        } catch (error: any) {
          console.log('Error:', error)
        }
      },
    }),
    getAdminFilters: builder.query({
      query: ({ table }) => ({
        url: `/filters/statuses?table=${table}`,
        method: 'GET',
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
})

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyMFAOTPMutation,
  useResendOTPMutation,
  useLazyGetAuthUserDetailsQuery,
  useEditProfileDetailsMutation,
  useChangePasswordMutation,
  useVerifyPasswordChangeMutation,
  useUpdatePasswordMutation,
  useVerifyPasswordResetOTPMutation,
  useVerifyLoginOTPMutation,
  useGetAdminFiltersQuery,
} = authApi
